import api from './authService';

export const marketplaceTaxReportApi = {
  list: async () => {
    const response = await api.get('/admin/marketplace-tax-reports');
    return response.data;
  },
  exportCsv: async ({ type, year, date_from, date_to, country }) => {
    const response = await api.get('/admin/marketplace-tax-reports/export', {
      params: {
        type,
        year,
        date_from,
        date_to,
        country,
        format: 'csv',
      },
      responseType: 'blob',
    });
    return response;
  },
  preview: async ({ type, year, date_from, date_to, country }) => {
    const response = await api.get('/admin/marketplace-tax-reports/export', {
      params: {
        type,
        year,
        date_from,
        date_to,
        country,
        format: 'json',
      },
    });
    return response.data;
  },
};
